import { Icon } from '@iconify/react'
import { ensureCustomDocuments } from '@/lib/raspadinha-campaigns'
import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import { RaspadinhaCustomDocumentsEditor } from './RaspadinhaCustomDocumentsEditor'
import { RaspadinhaPdfUploadField } from './RaspadinhaPdfUploadField'
import editStyles from '../CampanhasPage/CampanhaEditPage.module.css'

type RaspadinhaRegulamentoSectionProps = {
  form: RaspadinhaCampaign
  onFormChange: (next: RaspadinhaCampaign) => void
  disabled?: boolean
  onRegulationPdfChange: (url: string, name: string, file?: File | null) => void
  onCookiePolicyPdfChange: (url: string, name: string, file?: File | null) => void
  onCustomDocumentPdfChange: (index: number, url: string, name: string, file?: File | null) => void
}

export function RaspadinhaRegulamentoSection({
  form,
  onFormChange,
  disabled = false,
  onRegulationPdfChange,
  onCookiePolicyPdfChange,
  onCustomDocumentPdfChange,
}: RaspadinhaRegulamentoSectionProps) {
  const customDocuments = ensureCustomDocuments(form.custom_documents)

  return (
    <section className={editStyles.editSection} aria-labelledby="raspadinha-regulamento">
      <h2 id="raspadinha-regulamento" className={editStyles.editSectionTitle}>
        <Icon className={editStyles.editSectionTitleIcon} icon="mdi:file-document-outline" aria-hidden />
        Regulamento
      </h2>
      <div className={editStyles.editSectionBody}>
        <div className={editStyles.editSubsection}>
          <h3 className={editStyles.editSubsectionTitle}>Documentos padrão</h3>
          <div className={editStyles.editMediaGrid}>
            <RaspadinhaPdfUploadField
              label="Regulamento da campanha"
              hint="(PDF com as regras e condições do sorteio)"
              pdfUrl={form.regulation_pdf_url}
              pdfName={form.regulation_pdf_name}
              disabled={disabled}
              onPdfChange={onRegulationPdfChange}
            />
            <RaspadinhaPdfUploadField
              label="Políticas de Cookies"
              hint="(PDF com as regras de uso de cookies na experiência da campanha)"
              pdfUrl={form.cookie_policy_pdf_url}
              pdfName={form.cookie_policy_pdf_name}
              disabled={disabled}
              onPdfChange={onCookiePolicyPdfChange}
            />
          </div>
        </div>

        <div className={editStyles.editSubsection}>
          <RaspadinhaCustomDocumentsEditor
            documents={customDocuments}
            disabled={disabled}
            onDocumentsChange={(nextDocuments) => {
              onFormChange({
                ...form,
                custom_documents: ensureCustomDocuments(nextDocuments),
              })
            }}
            onDocumentPdfChange={onCustomDocumentPdfChange}
          />
        </div>
      </div>
    </section>
  )
}
